export default "__VITE_ASSET__aYTqJjV2__"